export default "__VITE_ASSET__P2P90rfS__"